<template>
  <div class="case-kalendar section">
    <div class="kalendar-dropdown">
      <img class="calendar-icon" src="@/assets/img/kalendar.svg" />
      <div class="mini-calendar-title">{{$t('components.calendar.mini_calendar.title')}}</div>
    </div>
    <div
      v-if="$route.name == 'Case' && is_a_moron"
      class="add-event add-button add-plus"
      @click="$router.push('kalendar/novi-dogadaj')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
      >
        <g>
          <g>
            <path
              fill="#0acab1"
              d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
            />
          </g>
        </g>
      </svg>
    </div>
    <div class="case-minikalendar-wrapper" v-if="is_a_moron">
      <div class="kalendar-broj-dogadanja">
        {{$t('components.calendar.mini_calendar.txt_1', {length : rasporedi_liste[2].length})}}
      </div>
      <div class="kalendar-mjesec">{{ getMonth() }} {{ getYear() }}</div>
      <div class="kalendar-img">
        <div class="opening-folder kalendar-wrapper">
          <div class="kalendar">
            <div class="minikalendar-day-grid">
              <div class="minikalendar-day">{{$t('components.calendar.mini_calendar.days_of_week.d1')}}</div>
              <div class="minikalendar-day">{{$t('components.calendar.mini_calendar.days_of_week.d2')}}</div>
              <div class="minikalendar-day">{{$t('components.calendar.mini_calendar.days_of_week.d3')}}</div>
              <div class="minikalendar-day">{{$t('components.calendar.mini_calendar.days_of_week.d4')}}</div>
              <div class="minikalendar-day">{{$t('components.calendar.mini_calendar.days_of_week.d5')}}</div>
              <div class="minikalendar-day">{{$t('components.calendar.mini_calendar.days_of_week.d6')}}</div>
              <div class="minikalendar-day sunday">{{$t('components.calendar.mini_calendar.days_of_week.d7')}}</div>
            </div>
            <div class="minikalendar-day-grid weekdays">
              <div v-if="fetching" class="center-spinner">
                <svg class="dot-spin" viewBox="0 0 50 50">
                  <circle
                    class="path"
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke-width="5"
                  ></circle>
                </svg>
              </div>
              <div
                v-else
                v-for="(dan, key) in raspon_datuma"
                :key="key"
                :class="dan.classes"
                @click="updateClickedClass(key)"
              >
                {{ dan.dan_enum }}
                <div class="today-events-mini">
                  <div
                    v-for="(added_class, key) in dan.added_classes.slice(0,4)"
                    :key="key"
                    :class="'dot d-' + added_class"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kalendar-sve pogledaj-sve" @click="goToPredmet('kalendar')">
        {{$t('components.calendar.mini_calendar.txt_2')}}
      </div>
    </div>
    <div class="case-kalendar-event"  :key="updateView">
      <!-- <div class="section-title">Događaji</div> -->
      <MiniEvent :events_list="finalni_arr_prikaza" ref="eventovi" />
      <div
        v-if="rasporedi_liste[0].length == 0"
        class="case-kalendar-event-empty mini"
      >
      {{$t('components.calendar.mini_calendar.no_events')}}
      </div>
      <Pagination v-show="rasporedi_liste[0].length != 0" ref="paginat" :finalni_arr_prikaza.sync="finalni_arr_prikaza" :br_redova="br_redova" :ukupna_lista="rasporedi_liste[0]"/>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import auth from "@/services/auth";
import person from "@/apiCallers/promise_handler_db/person";
import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint";
import MiniEvent from "@/components/calendarComponents/MiniEvent.vue";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import gsap from "gsap";
import permissioner from "../../services/permissioner";
import Pagination from "@/components/generalComponents/Pagination.vue";

export default {
  props:{
    is_a_moron : {
      typeof : Boolean,
      default : true
    }
  },
  components: { MiniEvent, Pagination },
  data() {
    return {
      //CURRENT CASE DATA BEGIN
      predmet_info: null,
      fiz_stranke: null,
      prav_protustranke: null,
      rootSpisi: [],
      // CURRENT CASE DATA END

      selected_month: moment().month(),
      accessToken: "",
      //dnevni - idx0, tjedni - idx1, mjesecni - idx2,
      rasporedi_liste: [[], [], []],
      selected_year: moment().year(),
      current_day: moment().date(),
      raspon_datuma: [],
      kategorija_liste: 1,
      categories: [
        { name: "Važno", class: "d-red" },
        { name: "Osobno", class: "d-grey" },
        { name: "Predmet", class: "d-green" },
        { name: "PSOD", class: "d-red" },
      ],
      br_redova: 2,
      finalni_arr_prikaza: [],
      fetching: true,
      sioVar: {
        type: {},
        required: false,
        default: null,
      },
      updateView:0,
    };
  },
  watch: {
    selected_month: function () {
      this.updateRasponDatuma();
      this.kategorija_liste = 1;
    },
    sioVar: function (){
      if (this.sioVar != null) {
        this.sioVar.socket.on("update task", async () => {
          this.finalni_arr_prikaza = [];
          await this.updateRasponDatuma();
          this.updateClickedClass(this.current_day);
        });
      }
    },
  },
  async created() {
    this.accessToken = this.$store.state.aToken 
    await this.updateRasponDatuma();
    this.sioVar = this.$store.state.sioVar
    
    let first_day = this.raspon_datuma.findIndex((obj) => obj.dan_enum == 1);
    this.current_day = first_day + moment().date() - 1;
    if (this.$route.params.uid != undefined) {
      await permissioner.checkUserInfo();

        let all_together = this.$store.state.current_selected_case

        this.predmet_info = all_together;
        this.fiz_stranke = all_together.connect_fiz_stranka;
        this.prav_protustranke = all_together.prav_connect_protustranka;
        this.rootSpisi = all_together.spis;
    }

    this.updateClickedClass(this.current_day);
    console.log(this.rasporedi_liste);
  },
  methods: {
    cleanClasses() {
      this.raspon_datuma.forEach((dan) => {
        dan.classes = dan.classes.replace("week", "");
        dan.classes = dan.classes.replace("today", "");
      });
    },

    //nedjelja je nula
    //ponedjeljak ima vrijednost 1
    updateClickedClass(list_idx) {
      //CLEAN values for day and week
      this.rasporedi_liste[0] = [];
      this.rasporedi_liste[1] = [];

      //Očisti sve klase
      this.cleanClasses();
      this.raspon_datuma[list_idx].classes =
        this.raspon_datuma[list_idx].classes + " today";
      let clicked_day = parseInt(
        moment(this.raspon_datuma[list_idx].fullDate).day()
      );

      // console.log("clicked day " + clicked_day);
      var end_idx = 0;
      var start_idx = 0;
      var kvocijent = Math.floor(list_idx / 7);
      // console.log(kvocijent);
      start_idx = kvocijent * 7;
      end_idx = start_idx + 6;
      this.getDayEventList(list_idx);
      this.getMonthEventList(start_idx, end_idx);

      this.kategorija_liste = 1;
      setTimeout(() => {
        this.$refs.paginat.calculatePageNumber();
        this.$refs.paginat.paginirajOdabrane();
      }, 10);
    },
    async updateRasponDatuma() {
      this.fetching = true;
      (this.rasporedi_liste = [[], [], []]), (this.raspon_datuma = []);
      if (this.$route.name == "Case") {
        await ms_calendar
          .getMiniCallendar(
            this.accessToken,
            this.selected_year,
            this.selected_month,
            this.$route.params.uid
          )
          .then((resp) => {
            // console.log(resp.data);
            this.fetching = false;
            this.raspon_datuma = resp.data.raspon_datuma;
            this.rasporedi_liste[2] = resp.data.filled_dates;
          });
      } else {
        let lawyer_id = await person.getSelf(this.accessToken);
        lawyer_id = lawyer_id.data.uid;

        await ms_calendar
          .getPersonMiniCalendar(
            this.accessToken,
            this.selected_year,
            this.selected_month,
            lawyer_id
          )
          .then((resp) => {
            this.fetching = false;
            // console.log(resp.data);
            this.raspon_datuma = resp.data.raspon_datuma;
            this.rasporedi_liste[2] = resp.data.filled_dates;
          });
      }
    },

    //update list of selected day events START

    getDayEventList(day_idx) {
      this.rasporedi_liste[0] = this.raspon_datuma[day_idx].date_events;
    },
    getMonth() {
      const month = moment().format("MMMM");
      return month[0].toUpperCase()+month.slice(1);
    },
    getYear() {
      return moment().year();
    },
    getMonthEventList(strt_d, end_d) {
      for (var i = strt_d; i <= end_d; i++) {
        this.rasporedi_liste[1] = this.rasporedi_liste[1].concat(
          this.raspon_datuma[i].date_events
        );
      }
    },
    goToPredmet(nastavak) {
      this.$router.push(nastavak);
    },
  },
  computed: {
    computed_date() {
      let date_arr = this.chosen_date.split("-");
      return this.mjeseci[parseInt(date_arr[1] - 1)] + ", " + date_arr[0] + ".";
    },
  },
  destroyed() {
    gsap.to(".router-wrapper", 0.5, {
      filter: "none",
      opacity: 1,
    });
    this.$store.state.event_details.popup_open = false;
  },
};
</script>

<style></style>